import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getAllPropertiesAllPages, getProperty, updateProperty } from '../propertyService';

// Query keys
export const propertyKeys = {
  all: ['properties'] as const,
  lists: () => [...propertyKeys.all, 'list'] as const,
  list: (filters: { limit?: number; nextToken?: string }) =>
    [...propertyKeys.lists(), filters] as const,
  details: () => [...propertyKeys.all, 'detail'] as const,
  detail: (id: string, sourceId: string) =>
    [...propertyKeys.details(), id, sourceId] as const,
};

// Get all properties with pagination
export const useProperties = (limit = 200) => {
  return useQuery({
    queryKey: propertyKeys.list({ limit }),
    queryFn: () => getAllPropertiesAllPages(limit),
  });
};

// Get a property by ID and source ID
export const useProperty = (id: string, sourceId: string) => {
  return useQuery({
    queryKey: propertyKeys.detail(id, sourceId),
    queryFn: () => getProperty(id, sourceId),
    enabled: !!id && !!sourceId,
  });
};



// Update property mutation
export const useUpdateProperty = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, sourceId, updates }: { id: string; sourceId: string; updates: any }) =>
      updateProperty(id, sourceId, updates),
    onSuccess: (updatedProperty, { id, sourceId }) => {
      // Invalidate and refetch property detail
      queryClient.invalidateQueries({ queryKey: propertyKeys.detail(id, sourceId) });
      // Invalidate property lists
      queryClient.invalidateQueries({ queryKey: propertyKeys.lists() });
    },
  });
};
